import { IVbUiDataGridValueFormatterParams } from './IVbUiDataGridValueFormatterParams';

export function yesNoValueFormatter(params: IVbUiDataGridValueFormatterParams): string {
	const translationKey: string = params.value ?
		'Yes' :
		'No';

	return params.context.getTranslation(translationKey);
}
